import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Header2 } from "@activecollab/components";
import PropTypes from "prop-types";
import queryString from "query-string";
import { Metadata } from "~/components/CalendarEvent/Metadata";
import { getCalendarByEventId, getCalendarEventById } from "~/store/selectors/selector.calendarEvents";
import { getUserTimezone } from "~/store/selectors/selector.configOptions";
import { CalendarEventOptions } from "./CalendarEventOptions";
import { makeEventForDate } from "../Calendar/calendarUtils";

export const Header = ({ id, children, occurrence, onEdit = () => null }) => {
  const _event = useSelector((state) => getCalendarEventById(state, id));
  const { search } = useLocation();
  const params = queryString.parse(search);
  const timezone = useSelector(getUserTimezone);
  const event = useMemo(() => {
    if (occurrence) {
      return makeEventForDate(_event, timezone, occurrence);
    }
    return makeEventForDate(_event, timezone, params?.date);
  }, [_event, occurrence, params?.date, timezone]);

  const calendar = useSelector((state) => getCalendarByEventId(state, id));
  const { name, created_by_name, created_by_id, created_by_email, created_on } = event;

  return (
    <div
      className="header tw-bg-primary-300 tw-items-center tw-flex tw-flex-col tw-px-8 tw-relative"
      data-testid="calendar-header"
    >
      <div className="tw-w-full tw-flex tw-justify-center tw-items-center">
        <div className="tw-flex tw-flex-col  tw-items-center tw-gap-1 tw-w-full">
          <div className="tw-flex tw-gap-[6px] tw-items-center tw-justify-center tw-mt-[10px] tw-w-full tw-px-12">
            <Header2 className=" tw-leading-[24px] tw-truncate tw-max-w-full">{name}</Header2>
            <CalendarEventOptions
              event={event}
              calendarId={event?.calendar_id}
              onEdit={onEdit}
            />
          </div>
          <Metadata
            createdByEmail={created_by_email}
            createdByName={created_by_name}
            createdOn={created_on}
            createdById={created_by_id}
            calendarName={calendar?.name}
          />
        </div>
      </div>
      <div className="tw-border-t tw-border-solid tw-border-0 tw-border-border-primary tw-w-full tw-my-3" />
      <div className="tw-w-full tw-pb-[10px]">{children}</div>
    </div>
  );
};

Header.propTypes = {
  id: PropTypes.number,
  occurrence: PropTypes.number,
  children: PropTypes.node,
  onEdit: PropTypes.func,
};
